import { Alert, AlertProps, message } from "antd";
import { ArgsProps } from "antd/lib/message";
import React, { FC } from "react";
import { CloseCircleOutlined, InfoCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { isString } from "lodash";

type MessageProps = Omit<ArgsProps, "content"> & {
  content?: React.ReactNode;
  type?: MessageContentProps["type"];
};

type MessageContentProps = AlertProps;

const CloseIcon = () => (
  <img src={`${settings.S3CDN}${settings.viewAssetsPath}close-white.png`} className="close-icon" />
);
const CheckMarkIcon = () => (
  <img src={`${settings.S3CDN}${settings.viewAssetsPath}checkMark.png`} className="sucess-icon" />
);

const msgIconEl = {
  success: CheckMarkIcon,
  error: CloseCircleOutlined,
  info: InfoCircleOutlined,
  warning: ExclamationCircleOutlined,
};

const MessageContent: FC<MessageContentProps> = props => {
  const { icon, type = "error", closeIcon } = props;

  const DefaultIcon = msgIconEl[type];

  return (
    <Alert
      type={type}
      icon={icon || <DefaultIcon />}
      closeIcon={closeIcon || <CloseIcon />}
      showIcon
      closable
      {...props}
    ></Alert>
  );
};

const defaultMessageProps = {
  content: "",
  type: "error",
  duration: 5,
} as MessageProps;

export function Message(props: MessageProps | string) {
  if (!props) {
    return;
  }

  const _props = isString(props) ? { ...defaultMessageProps, content: props } : { ...defaultMessageProps, ...props };

  const { type, content } = _props;

  return message.open({
    type: type,
    icon: <></>,
    className: "custom-editor-msg",
    ..._props,
    content: <MessageContent message={content} type={type} onClose={() => message.destroy()} />,
  });
}
